import { CreditCheckResult } from 'modules/cm/Credit/Credit';
import { NullableRecursive } from 'utils/types';

export enum FieldsLabels {
  ReferenceNumber = 'Credit reference number',
  CreditScore = 'Delphi score',
  DateOfSearch = 'Date of search',
}

export interface CreditForm extends CreditCheckResult {}

export interface Form extends NullableRecursive<CreditCheckResult> {}

export const createCreditCheckResult = (): Form => {
  return {
    type: null,
    referenceNumber: null,
    creditScore: null,
    dateOfSearch: null,
  };
};
